import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ConnectorConfigurationsTable } from "ConnectorConfigurations/Components/ConnectorConfigurationsTable";
import { CreateConnectorConfigurationDialog } from "ConnectorConfigurations/Components/CreateConnectorConfigurationDialog";
import type { ConnectorConfigurationListItemDto } from "Infrastructure/Api/Api";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { type FC, useState } from "react";

export const ConnectorConfigurationsPage: FC = () => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [editConfig, setEditConfig] = useState<
		ConnectorConfigurationListItemDto | undefined
	>(undefined);

	const handleCreateClick = () => {
		setEditConfig(undefined);
		setIsDialogOpen(true);
	};

	const handleEditClick = (config: ConnectorConfigurationListItemDto) => {
		setEditConfig(config);
		setIsDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setIsDialogOpen(false);
		setEditConfig(undefined);
	};

	return (
		<AuthenticatedLayout title="Connector Configurations">
			<Box>
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					mb={2}
				>
					<Typography variant="h4">Connector Configurations</Typography>
					<Button
						variant="contained"
						color="primary"
						startIcon={<AddIcon />}
						onClick={handleCreateClick}
					>
						Create
					</Button>
				</Stack>
				<ConnectorConfigurationsTable onEdit={handleEditClick} />
				<CreateConnectorConfigurationDialog
					open={isDialogOpen}
					onClose={handleCloseDialog}
					editData={editConfig}
				/>
			</Box>
		</AuthenticatedLayout>
	);
};
